import Container from '@ui/container/container';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';
import Text from '@ui/text/text/text';
import TooltipPortal from '@ui/tooltip-portal/tooltip-portal';

/**
 * Indicator for audience lists that one of the event's campaigns sends to. `chip` matches the
 * member-count chip on the grid card; `icon` is the compact form for list-view rows. Uses the
 * campaigns icon from the sidebar.
 */
const UsedInCampaignsBadge = ({ variant }: { variant: 'chip' | 'icon' }) => {
  return (
    <TooltipPortal
      childrenWrapperClass="flex"
      keepOpenOnContentHover={false}
      styles={{ padding: '8px 4px' }}
      verticalOffset={-4}
      tooltipContent={
        <Text design="GlobalIcoText1" className="P2" maxWidth="290px">
          Used in this event's campaigns.
        </Text>
      }
    >
      {variant === 'chip' ? (
        <Container className="flex radius-8 padding-v-8 padding-h-10 ai-center gap-6" design="GlobalCont2">
          <Icon name={ICONS.AI_SEND_MESSAGE} size={12} color="var(--global-ico-text-2)" />
          <Text className="C1" design="GlobalIcoText2" whiteSpace="nowrap">
            Campaigns
          </Text>
        </Container>
      ) : (
        <Icon name={ICONS.AI_SEND_MESSAGE} size={12} color="var(--global-ico-text-2)" />
      )}
    </TooltipPortal>
  );
};

export default UsedInCampaignsBadge;
